<div
  *ngIf="canShow"
  class="company-switcher"
  [class.company-switcher--mobile]="variant === 'mobile'"
  [class.company-switcher--sidebar]="variant === 'sidebar'"
  [enabled]="isOpen"
  (appOutsideClick)="close()"
>
  <button
    type="button"
    class="company-switcher__trigger"
    [class.company-switcher__trigger--clickable]="canSwitch"
    [attr.aria-expanded]="isOpen"
    [attr.aria-haspopup]="canSwitch ? 'dialog' : null"
    [disabled]="!canSwitch || isSwitching"
    (click)="toggle()"
  >
    <svg class="company-switcher__logo" aria-hidden="true">
      <use spriteVersion iconName="company-colored-home-icon"></use>
    </svg>

    <span class="company-switcher__name" [title]="currentCompanyName">
      {{ currentCompanyName }}
    </span>

    <svg *ngIf="canSwitch" class="company-switcher__arrow" aria-hidden="true">
      <use spriteVersion [iconName]="isOpen ? 'arrow-up' : 'arrow-down'"></use>
    </svg>
  </button>

  <div *ngIf="isOpen" class="company-switcher__panel" [attr.role]="'dialog'" aria-label="Switch company">
    <div class="company-switcher__panel-title">
      Switch Company
    </div>

    <div *ngIf="isLoading" class="company-switcher__loading" aria-hidden="true">
      <div class="company-switcher__skeleton-list">
        <div
          *ngFor="let _ of loaderSkeletonRows; trackBy: trackByIndex"
          class="company-switcher__skeleton-row"
        >
          <span class="company-switcher__skeleton-name"></span>
          <span class="company-switcher__skeleton-role"></span>
        </div>
      </div>
    </div>

    <div *ngIf="!isLoading" class="company-switcher__content">
      <div class="company-switcher__list" [class.company-switcher__list--scrollable]="isScrollableList">
        <div class="company-switcher__list-inner">
          <button
            *ngFor="let company of companies; trackBy: trackByCompanyId"
            type="button"
            class="company-switcher__row"
            [class.company-switcher__row--active]="isActiveCompany(company)"
            [disabled]="isActiveCompany(company) || isSwitching"
            (click)="switchToCompany(company)"
          >
            <span class="company-switcher__row-name" [title]="company.name">{{ company.name }}</span>
            <span class="company-switcher__role" [ngClass]="getRoleClass(company)">
              {{ getRoleLabel(company) }}
            </span>
          </button>
        </div>
      </div>

      <div class="company-switcher__footer">
        <button
          type="button"
          class="company-switcher__all-companies"
          [disabled]="isSwitching"
          (click)="openAllCompanies()"
        >
          All Companies
        </button>
      </div>
    </div>
  </div>
</div>
